export default {
    tool: "fa-wrench",
    data_input: "fa-file-o",
    data_collection_input: "fa-folder-o",
    subworkflow: "fa-sitemap fa-rotate-270",
    parameter_input: "fa-pencil",
    pause: "fa-pause",
};
